import { useRoutes } from 'react-router-dom';
import { routes } from './config';

export const Routes = () => {
  return useRoutes(routes);
};
